/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar6 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar6", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 15.115234 14.306641 C 16.535234 14.306641 17.653844 15.137219 17.839844 16.324219 L 16.085938 16.324219 C 15.974937 15.938219 15.588375 15.689453 15.109375 15.689453 C 14.240375 15.689453 13.688953 16.586625 13.751953 17.890625 L 13.845703 17.890625 C 14.157703 17.231625 14.792422 16.865234 15.607422 16.865234 C 16.941422 16.865234 17.927734 17.857312 17.927734 19.195312 C 17.927734 20.679312 16.760375 21.728516 15.109375 21.728516 C 14.109375 21.728516 13.28925 21.328938 12.78125 20.585938 C 12.30625 19.960938 12.058594 19.081875 12.058594 18.046875 C 12.058594 15.736875 13.224234 14.306641 15.115234 14.306641 z M 15.095703 18.150391 C 14.464703 18.150391 13.986328 18.623281 13.986328 19.238281 C 13.986328 19.863281 14.470703 20.351562 15.095703 20.351562 C 15.720703 20.351562 16.208984 19.869047 16.208984 19.248047 C 16.208984 18.624047 15.729703 18.150391 15.095703 18.150391 z" />
      </svg>
    );
  }
}

IconCalendar6.defaultProps = {
  className: null
};

IconCalendar6.propTypes = {
  className: PropTypes.string
};

export default IconCalendar6;
